export default "__VITE_ASSET__2f1d874e__"